import { render } from "./SurveyResults.vue?vue&type=template&id=30a0dda5&scoped=true"
import script from "./SurveyResults.vue?vue&type=script&lang=js"
export * from "./SurveyResults.vue?vue&type=script&lang=js"

import "./SurveyResults.vue?vue&type=style&index=0&id=30a0dda5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a0dda5"]])

export default __exports__